import React from 'react'
import CreateTemplateCommon from '../../../../globalcomponents/admincomponents/createtemplatecommon'

const CreateTemplate = () => {
  return (
    <>
      <CreateTemplateCommon header="Create Template" updateContent=""/>
    </>
  )
}
export default CreateTemplate